import { PropTypes } from "prop-types";
import { useEffect, useState } from "react";
import { StyledUserCard } from "../../../styles/StyledUserCard/StyledUserCard";
import { MoreActions } from "../../MoreActions";
import { Select } from "../../Select";
import CloseIcon from "../../../assets/img/icons/close.svg";
import SaveIcon from "../../../assets/img/icons/save.svg";
import { changeUnitMemberRole } from "../../../api/unit/members";
import { useUnitContext } from "../../../context/unitContext";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { Role } from "../../../constants/role";

// Every member has the "member" role; the unit admin (head of the unit) additionally has "admin"
const roleOptions = [
	{ value: Role.admin, label: "Unit admin" },
	{ value: Role.member, label: "Member" },
];

export default function MemberCard({
	data,
	color,
	openDropdowns,
	setOpenDropdowns,
	direction,
	moreActionsPosition,
	openModal,
	refetch,
	showOptions,
}) {
	const { axiosPrivate } = useAxiosPrivate();
	const { id: unitId } = useUnitContext();
	const [edit, setEdit] = useState(false);
	const { roles, user } = data;
	const { id, firstName, lastName } = user;
	const name = firstName + " " + lastName;
	const currentRole = roles.includes(Role.admin) ? Role.admin : Role.member;
	const [value, setValue] = useState(currentRole);

	useEffect(() => {
		setValue(currentRole);
	}, [currentRole, edit]);

	const handleRoleChange = async () => {
		setEdit(false);
		await changeUnitMemberRole(axiosPrivate, refetch, unitId, id, {
			roles: value === Role.admin ? [Role.member, Role.admin] : [Role.member],
		});
	};

	let acronym = "";
	name.split(" ").map((e, i) => {
		if (i < 2) acronym += e.split("")[0];
	});

	return (
		<StyledUserCard color={color}>
			{showOptions && (
				<MoreActions
					type={`p${id}`}
					options={[
						{
							display: true,
							testId: `p${id}-delete`,
							name: "Remove member",
							click: () => openModal(id),
						},
						{
							display: true,
							testId: `p${id}-role`,
							name: "Change role",
							click: () => setEdit(true),
						},
					]}
					isOpen={openDropdowns}
					setIsOpen={setOpenDropdowns}
					isDisabled={false}
					direction={direction}
					moreActionsPosition={moreActionsPosition}
				/>
			)}
			<div className="user-header">
				<div className="user-picture">
					<span>{acronym}</span>
				</div>
				<div>
					<span className="user-label">Name</span>
					<h5>{name}</h5>
				</div>
			</div>
			<span className="user-label">Role</span>
			{edit ? (
				<>
					<Select options={roleOptions} value={value} setMatterId={setValue} id="role" name="role" data-testid="role" />
					<div className="user-role-buttons">
						<img
							onClick={() => {
								handleRoleChange();
							}}
							src={SaveIcon}
							alt={SaveIcon}
							role="img"
						/>
						<img
							onClick={() => {
								setEdit(false);
							}}
							src={CloseIcon}
							alt={CloseIcon}
							role="img"
						/>
					</div>
				</>
			) : (
				<h5>{roleOptions.find((option) => option.value === currentRole).label}</h5>
			)}
		</StyledUserCard>
	);
}

MemberCard.propTypes = {
	data: PropTypes.object,
	color: PropTypes.string,
	openDropdowns: PropTypes.object,
	setOpenDropdowns: PropTypes.func,
	refetch: PropTypes.func,
	direction: PropTypes.string,
	moreActionsPosition: PropTypes.string,
	openModal: PropTypes.func,
	showOptions: PropTypes.bool,
};
